<template>
    <div :id="`voiceMessagePlayer`" class="sc-message--text" ref="voiceMessage">
        <div @click="toggleAudio()">
            <md-icon style="color: var(--customer-text-color); background: transparent !important"
                >{{ paused ? "play_circle" : "pause_circle" }}
            </md-icon>
        </div>
        <av-waveform
            :playtime="false"
            :playtimeWithMs="false"
            :playtimeTextBottom="false"
            :playtimeSliderWidth="10"
            :noplayedLineColor="'white'"
            :playedLineColor="backgroundColorFirst"
            :playedLineWidth="10"
            :audio-src="`https://static.supsis.live/${message.raw.asset.path + message.raw.asset._id}${
                message.raw.asset.ext ? '.' + message.raw.asset.ext : ''
            }`"
            :playtimeFontSize="25"
        ></av-waveform>
    </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";

export default {
    name: "VoiceMessage",
    props: ["message"],
    data: () => ({
        paused: true,
    }),
    computed: {
        ...mapState({
            backgroundColorFirst: (state) =>
                _.get(state.setting, "settings.chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst"),
        }),
    },
    methods: {
        toggleAudio() {
            const audio = this.$refs.voiceMessage.querySelector(`audio`);
            audio[audio.paused ? "play" : "pause"]();
            this.paused = !this.paused;
        },
    },
};
</script>

<style lang="scss" scoped>
#voiceMessagePlayer > :nth-child(2) > :nth-child(1) {
    display: none;
}
 
#voiceMessagePlayer {
    max-width: 300px !important;
    display: flex;
    align-items: center;

    i.md-icon {
        font-style: normal !important;
        background-color: none !important;
        padding: 0 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/messages/VoiceMessage.vue